import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { compose } from "redux";
import { connect } from "react-redux";
import {
  selectHasAddress,
  selectHasPersonalInfo,
  savePersonalInfo_Begin,
  checkIfCustomerHasAddress_Begin,
} from "../../../state/ducks/calculation/index";
import { alertActions } from "../../../state/ducks/alert/index";
import $ from "jquery";
import NumberFormat from "react-number-format";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import tr from "date-fns/locale/tr";
import MaskedInput from "react-text-mask";
import moment from "moment";
import StaticModal from "../shared/StaticModal";

function formKontrol() {
  var kimlikNo = document.getElementById("kimlikNo").value;
  var ad = document.getElementById("ad").value;
  var soyad = document.getElementById("soyad").value;
  var dogumTarihi = document.getElementById("dogumTarihi").value;

  var durum = 1;
  if (kimlikNo == "") {
    durum = 0; // Konu Boş
    $("#kimlikNo").parent().addClass("t-error");
    $("#kimlikNo").next().html("<i class='t-icon-error text-danger'></i>");
    $("#kimlikNo_hatamesaj").html("Tutar alanı Boş Bırakılamaz");
  } else {
    if (tcnoVerify(kimlikNo) === false) {
      durum = 0; // Konu Boş
      $("#kimlikNo").parent().addClass("t-error");
      $("#kimlikNo").next().html("<i class='t-icon-error text-danger'></i>");
      $("#kimlikNo_hatamesaj").html("Kimlik no hatalıdır kontrol ediniz.");
    }
    else {
      $("#kimlikNo").parent().removeClass("t-error");
      $("#kimlikNo").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#kimlikNo_hatamesaj").html("");
    }
  }
  if (ad == "") {
    durum = 0; // Mesaj Boş
    $("#ad").parent().addClass("t-error");
    $("#ad").next().html("<i class='t-icon-error text-danger'></i>");
    $("#ad_hatamesaj").html("Ad alanı boş bırakılamaz");
  } else {
    $("#ad").parent().removeClass("t-error");
    $("#ad").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#ad_hatamesaj").html("");
  };

  if (soyad == "") {
    durum = 0; // Mesaj Boş
    $("#soyad").parent().addClass("t-error");
    $("#soyad").next().html("<i class='t-icon-error text-danger'></i>");
    $("#soyad_hatamesaj").html("Soyad alanı boş bırakılamaz");
  } else {
    $("#soyad").parent().removeClass("t-error");
    $("#soyad").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#soyad_hatamesaj").html("");
  };
  if (dogumTarihi == "") {
    durum = 0; // Mesaj Boş
    $("#dogumTarihi").parent().addClass("t-error");
    $("#dogumTarihi").next().html("<i class='t-icon-error text-danger'></i>");
    $("#dogumTarihi_hatamesaj").html("Doğum tarihi alanı boş bırakılamaz");
  } else {
    $("#dogumTarihi").parent().removeClass("t-error");
    $("#dogumTarihi").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#dogumTarihi_hatamesaj").html("");
  };

  return durum;

}

function tcnoVerify(tcno) {
  // geleni her zaman String'e çevirelim!
  tcno = String(tcno);

  // tcno '0' karakteri ile başlayamaz!
  if (tcno.substring(0, 1) === "0") {
    return false;
  }
  // Tcno 11 karakter uzunluğunda olmalı!
  if (tcno.length !== 11) {
    return false;
  }

  /**
          Aşağıdaki iki kontrol için toplamları hazır ediyoruz
          - o anki karakteri sayıya dönüştür
          - tek haneleri ayrıca topla (1,3,5,7,9)
          - çift haneleri ayrıca topla (2,4,6,8)
          - bütün haneleri ayrıca topla
      **/
  var hane_cift = 0;
  var hane_tek = 0;
  var ilkon_array = tcno.substr(0, 10).split("");
  var ilkon_total = (hane_tek = hane_cift = 0);
  var j = 0;
  for (var i = (j = 0); i < 9; ++i) {
    j = parseInt(ilkon_array[i], 10);
    if (i & 1) {
      // tek ise, tcnin çift haneleri toplanmalı!
      hane_cift += j;
    } else {
      hane_tek += j;
    }
    ilkon_total += j;
  }

  /**
          KONTROL 1:
          1. 3. 5. 7. ve 9. hanelerin toplamının 7 katından, 
          2. 4. 6. ve 8. hanelerin toplamı çıkartıldığında, 
          elde edilen sonucun Mod10'u bize 10. haneyi verir
      **/
  if ((hane_tek * 7 - hane_cift) % 10 !== parseInt(tcno.substr(-2, 1), 10)) {
    return false;
  }

  /**
          KONTROL 2:
          1. 2. 3. 4. 5. 6. 7. 8. 9. ve 10. hanelerin toplamından
          elde edilen sonucun Mod10'u bize 11. haneyi vermelidir.
          NOT: ilk 9 haneyi üstteki FOR döndüsünde zaten topladık!
      **/
  ilkon_total += parseInt(ilkon_array[9], 10);
  if (ilkon_total % 10 !== parseInt(tcno.substr(-1), 10)) {
    return false;
  }

  return true;
}

const PersonalInfo = ({
  history,
  checkIfCustomerHasAddress_Begin,
  savePersonalInfo_Begin,
  hasAddress,
  hasPersonalInfo,
  showError,
}) => {
  useEffect(() => {
    checkIfCustomerHasAddress_Begin();
    $(".react-datepicker-wrapper").addClass("form-control");
    $(".bg-img-tiled").removeClass("x_auto");
    handlePersonalInfoLoad();
  }, []);

  const [state, setState] = useState({
    kartId: "",
    kimlikNo: "",
    ad: "",
    soyad: "",
    dogumTarihi: "",
    dogumTarihiReadOnly: false,
    kimlikNoReadOnly: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value.toLocaleUpperCase() });
  };

  const handleChangeDate = (date) => {
    setState({
      ...state,
      dogumTarihi: date,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formKontrol() == 1) {
      const postData = {
        vatandaslikNo: state.kimlikNo,
        ad: state.ad,
        soyad: state.soyad,
        dogumTarihi: moment(state.dogumTarihi).format("DD.MM.yyyy"),
        adresiVarMi: hasAddress.sehirId === 0 || hasAddress.adresEkle,
      };
      const res = savePersonalInfo_Begin(postData);
      if (res === null || res === undefined) {
      } else {
        showError(res);
      }
    }
  };

  const handlePersonalInfoLoad = () => {
    if (!hasPersonalInfo) {
      history.push("/Home/SmartCalculation");
    }

    var kimlikNo, ad, soyad, dogumTarihi, kimlikNoReadOnly;

    if (
      hasPersonalInfo != null &&
      hasPersonalInfo?.vatandaslikNo !== "" &&
      hasPersonalInfo?.vatandaslikNo != null
    ) {
      kimlikNo = hasPersonalInfo.vatandaslikNo;
      if (hasPersonalInfo?.dogumTarihi === "" ||
        hasPersonalInfo?.dogumTarihi === null) {
        kimlikNoReadOnly = true;
      }
    }

    if (
      hasPersonalInfo != null &&
      hasPersonalInfo?.dogumTarihi !== "" &&
      hasPersonalInfo?.dogumTarihi !== null
    ) {
      dogumTarihi = moment(hasPersonalInfo?.dogumTarihi).valueOf();
    }

    if (
      hasPersonalInfo != null &&
      hasPersonalInfo?.ad !== "" &&
      hasPersonalInfo?.ad !== null
    ) {
      ad = hasPersonalInfo.ad;
    }

    if (
      hasPersonalInfo != null &&
      hasPersonalInfo?.soyad !== "" &&
      hasPersonalInfo?.soyad !== null
    ) {
      soyad = hasPersonalInfo.soyad;
    }

    setState({
      kimlikNo: kimlikNo,
      ad: ad,
      soyad: soyad,
      dogumTarihi: dogumTarihi,
      kimlikNoReadOnly: kimlikNoReadOnly
    });
  };

  $(function () {
    $(".without-number").keydown(function (e) {
      if (e.ctrlKey || e.altKey) {
        e.preventDefault();
      } else {
        var key = e.keyCode;
        if (
          !(
            key == 8 ||
            key == 9 ||
            key == 32 ||
            key == 46 ||
            (key >= 35 && key <= 40) ||
            (key >= 65 && key <= 90) ||
            key == 186 ||
            (key >= 191 && key <= 222)
          )
        ) {
          e.preventDefault();
        }
      }
    });
  });

  return (
    <div className="container-fluid">
      {/* yesil Alan*/}
      <div className="row" style={{ padding: "3%" }}>
        <div className="col-12">
          {/* KUTU 1 */}
          <div className="row no-gutters t-kutu t-mavicizgi">
            <div
              className="col bosluk backright"
              style={{
                backgroundImage: 'url("/assets/img/backgrounds/back_right_mavi.jpg")'
              }}
            >
              {/* içerikler */}
              {/* Başlık */}
              <div className="row no-gutters pb-4">
                <div clss="col-auto">
                  <i className="t-icon-document-alt-stroke icon" />
                </div>
                <div className="col d-flex flex-column justify-content-center">
                  <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                    Kimlik Bilgileri
                  </div>
                  <span className="altBaslik">
                    İşleme devam edebilmek için lütfen kimlik bilgilerinizi giriniz.
                  </span>
                </div>
              </div>
              <div className="row no-gutters">

                {/* Semt Mahalle */}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">Ad</span>
                </div>
                <div className="col-12">
                  <div className="t-icInput">
                    <div>
                      <i className="t-icon-user1" />
                    </div>
                    <input
                      id="ad"
                      name="ad"
                      type="text"
                      className="without-number"
                      placeholder="Adınız"
                      maxLength="30"
                      value={state.ad}
                      onChange={handleChange}
                    />
                    <div />
                  </div>
                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="ad_hatamesaj"
                />
                {/* Cadde */}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">Soyad</span>
                </div>
                <div className="col-12">
                  <div className="t-icInput">
                    <div>
                      <i className="t-icon-user1" />
                    </div>
                    <input
                      id="soyad"
                      name="soyad"
                      className="without-number"
                      type="text"
                      maxLength="30"
                      placeholder="Soyadınız"
                      value={state.soyad}
                      onChange={handleChange}
                    />
                    <div />
                  </div>
                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="soyad_hatamesaj"
                />
                {/* Sokak */}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">Kimlik No</span>
                </div>
                <div className="col-12">
                  <div className="t-icInput">
                    <div>
                    <img src="/assets/img/svg/icon_ayyildiz.svg" style={{ width: '25px' }} />
                    </div>
                    <NumberFormat
                      displayType={"input"}
                      format="###########"
                      id="kimlikNo"
                      name="kimlikNo"
                      placeholder="T.C. Kimlik Numaranız"
                      value={state.kimlikNo}
                      onChange={handleChange}
                      readOnly={state.kimlikNoReadOnly}
                    />
                    <div />
                  </div>
                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="kimlikNo_hatamesaj"
                />
                {/* Kapı No */}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">Doğum Tarihi</span>
                </div>

                <div className="col-12 m-takvim">


                  <div className="input-group">
                    <div className="input-group-prepend" onClick={e => $(".dogum_Tarihi").focus()}>
                      <span className="input-group-text m-takvimiconhizalama" id="basic-addon2">
                        <i className="t-icon-calendar1"></i>
                      </span>
                    </div>
                    <DatePicker
                      id="dogumTarihi"
                      name="dogumTarihi"
                      onChange={handleChangeDate}
                      className="t-icInput dogum_Tarihi m-datepicker"
                      placeholderText="Doğum Tarihiniz"
                      dateFormat="dd.MM.yyyy"
                      locale={tr}
                      value={state.dogumTarihi}
                      selected={state.dogumTarihi}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      maxDate={
                        new Date(
                          new Date().setFullYear(new Date().getFullYear() - 18)
                        )
                      }
                      autoComplete="off"
                      customInput={
                        <MaskedInput
                          mask={[
                            /\d/,
                            /\d/,
                            ".",
                            /\d/,
                            /\d/,
                            ".",
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                          ]}
                          keepCharPositions={true}
                          guide={true}
                        />
                      }
                    />
                  </div>

                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="dogumTarihi_hatamesaj"
                />

                {/* Button */}
                <div className="col-12 d-flex justify-content-center pb-3">
                  <button className="t-icButonMavi" onClick={handleSubmit}>
                    <span>Devam</span>
                    <i className="t-icon-arrow-right2" />
                  </button>
                </div>
              </div>
              {/* içerikler BİTTİ */}
            </div>
            <div className="col-auto renk" />
          </div>
          {/* KUTU 1 BİTTİ */}
        </div>
      </div>
      {/* Duyurlar Baslık*/}
      {/* duyrular Bitti*/}
      <div className="row" style={{ height: 30 }} />
      <StaticModal></StaticModal>
    </div>

  );
};

const mapStateToProps = (state) => ({
  hasAddress: selectHasAddress(state),
  hasPersonalInfo: selectHasPersonalInfo(state),
});

const mapDispatchToProps = (dispatch) => ({
  savePersonalInfo_Begin: (data) => dispatch(savePersonalInfo_Begin(data)),
  checkIfCustomerHasAddress_Begin: () =>
    dispatch(checkIfCustomerHasAddress_Begin()),
  showError: (message) => dispatch(alertActions.showError(message)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(PersonalInfo);
